module.exports = __webpack_public_path__ + "media/images/double_circle_back-d8921e563e7abe169fb707c089961404.svg";